import { render, staticRenderFns } from "./NbnOrderCorrection.vue?vue&type=template&id=63f12792"
import script from "./NbnOrderCorrection.vue?vue&type=script&lang=js"
export * from "./NbnOrderCorrection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports